import { ja } from ".";

export const queries = {
  keys: {
    error: "error",
    signUp: "signUp",
    signIn: "signIn",
    signOut: "signOut",
    lineNotify: "lineNotify",
  },
  values: {
    error: {
      default: "default",
      badRequest: "badRequest",
      unauthorized: "unauthorized",
      forbidden: "forbidden",
      notFound: "notFound",
    },
    signUp: {
      success: "success",
    },
    signIn: {
      success: "success",
    },
    signOut: {
      success: "success",
    },
    lineNotify: {
      enabled: "enabled",
      disabled: "disabled",
    },
  },
  messages: {
    error: {
      default: ja.error.default,
      badRequest: ja.error.badRequest,
      unauthorized: ja.error.unauthorized,
      forbidden: ja.error.forbidden,
      notFound: ja.error.notFound,
    },
    signUp: {
      success: ja.signUp,
    },
    signIn: {
      success: ja.signIn,
    },
    signOut: {
      success: ja.signOut,
    },
    lineNotify: {
      enabled: ja.lineNotify.enabled,
      disabled: ja.lineNotify.disabled,
    },
  },
} as const;

export interface Queries {
  error: keyof typeof queries.values[typeof queries.keys.error];
  signUp: keyof typeof queries.values[typeof queries.keys.signUp];
  signIn: keyof typeof queries.values[typeof queries.keys.signIn];
  signOut: keyof typeof queries.values[typeof queries.keys.signOut];
  lineNotify: keyof typeof queries.values[typeof queries.keys.lineNotify];
}
